type ColloLike = {
    barcode?: string
    type?: string
    description?: string
    weight?: number
    length?: number
    width?: number
    height?: number
}

// The server adds a collo without any content to every address without colli, such a collo carries no information for the user
export function isEmptyCollo(collo: ColloLike) {
    return (!collo.barcode || collo.barcode === 'no barcode') &&
        !collo.type &&
        !collo.description &&
        !collo.weight &&
        !collo.length &&
        !collo.width &&
        !collo.height
}

type AddressCollo = ColloLike & {
    pickupAddressIndex?: number
    deliveryAddressIndex?: number
}

// The server only adds an empty collo to an address without colli, an empty collo that shares an address with another
// collo was made by the user (e.g. a collo whose barcode was removed)
export function isServerAddedEmptyCollo<T extends AddressCollo>(collo: T, colli: T[]) {
    if (!isEmptyCollo(collo)) {
        return false
    }

    const hasAddressIndex = typeof collo.pickupAddressIndex === 'number' || typeof collo.deliveryAddressIndex === 'number'

    return !colli.some((otherCollo) => otherCollo !== collo && (
        !hasAddressIndex ||
        (typeof collo.pickupAddressIndex === 'number' && otherCollo.pickupAddressIndex === collo.pickupAddressIndex) ||
        (typeof collo.deliveryAddressIndex === 'number' && otherCollo.deliveryAddressIndex === collo.deliveryAddressIndex)
    ))
}

type HiddenCollo = ColloLike & {
    pickupAddressIndex?: number
    deliveryAddressIndex?: number
    status?: string
}

// A hidden empty collo is only linked to the address it was added for, when it is shown as a new collo it gets the
// default address of a new collo for the other side and loses its status (an empty delivery collo is 'athub'), so the
// server sets the status that fits its addresses
export function showHiddenCollo<T extends HiddenCollo>(collo: T, barcode: string, pickupAddressIndex: number, deliveryAddressIndex: number): Omit<T, 'status'> {
    const shownCollo = {
        ...collo,
        barcode,
        pickupAddressIndex: typeof collo.pickupAddressIndex === 'number' ? collo.pickupAddressIndex : pickupAddressIndex,
        deliveryAddressIndex: typeof collo.deliveryAddressIndex === 'number' ? collo.deliveryAddressIndex : deliveryAddressIndex
    }

    delete shownCollo.status

    return shownCollo
}
